export enum RecipientMethod {
  Manually = 'manually',
  UnrestrictedLink = 'unrestricted-link',
  ImportFile = 'import-file',
  ImportCopyPaste = 'import-copy-paste',
  Contacts = 'contacts',
}
